<template>
</template>

<script>
export default {
    name: 'emailCenter',
    data() {
        return {
            row:{}
        }
    },
    created() {
        let query = this.$route.query
        this.row = {...query}
        console.log(this.row,'query')
        if(this.row.accessToken){
            let url = `${this.global.BASE_URL}/msi/oa/external/email/saveEmailToken`;
            this.$axios.post(url, {data:{...this.row}}).then(res => {
                if(res.data.code === '0000'){
                    this.goEmail()
                }
            });
        }
    },
    methods: {
        goEmail(){
            let url = `${this.global.BASE_URL}/msi/oa/external/email/emailSso?sys=1`;
            this.$axios.get(url, {}).then(res => {
                if(res.data.code === '0000'){
                console.log(res.data.data,'res.data.data')
                window.open(res.data.data,'_blank');
                }
            });
        },
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/email-center/index.vue